// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3YV0w","colMaxWidth":"Table_colMaxWidth__2grcQ"};